const client = process.env.VUE_APP_TYPE
import(`core/skins/${client}/${client}.sass`)
